module.exports = __webpack_public_path__ + "static/media/animal-00.2036c046.mp3";